<div class="sc-address-load section-container">
  <sc-title
    [content]="title"
    type="h3"
    [class.sc-color-grey-2]="!editMode"
  ></sc-title>
  <ng-container *ngIf="editMode">
    <div class="address">Dirección</div>
    <form [formGroup]="addressLoadFormGroup">
      <div class="address__street">
        <sc-input formControlName="streetName" label="Calle" placeholder="Montevideo"></sc-input>
      </div>
      <div class="address__number">
        <sc-input formControlName="number" label="Número" placeholder="1123"></sc-input>
      </div>
      <div class="address__floor">
        <sc-input formControlName="floor" type="number" label="Piso (Opcional)" placeholder="Ej: 3"></sc-input>
      </div>
      <div class="address__department">
        <sc-input formControlName="department" label="Dpto (Opcional)" placeholder="Ej: D"></sc-input>
      </div>
    </form>
    <sc-button (onClick)="onSubmit()" [disabled]="addressLoadFormGroup.status !== 'VALID'" id="address-load-next-step">Siguiente</sc-button>
  </ng-container>
  <div class="section-submitted-data" *ngIf="!editMode">
    <div>
      <div>
        Calle<br>
        <strong>{{addressLoadFormGroup.value['streetName'] || '-'}}</strong>
      </div>
      <div>
        Número<br>
        <strong>{{addressLoadFormGroup.value['number'] || '-'}}</strong>
      </div>
      <div>
        <span>Piso (Opcional)</span><br>
        <strong>{{addressLoadFormGroup.value['floor'] || '-'}}</strong>
      </div>
      <div>
        <span>Dpto (Opcional)</span><br>
        <strong>{{addressLoadFormGroup.value['department'] || '-'}}</strong>
      </div>
    </div>
  </div>
</div>

